import gql from 'graphql-tag';

import integrationFragment from '../fragments/integrationFragment';

export const mutationUpdateIntegration = gql`
  mutation updateIntegration (
    $id: DokkioID!
    $name: String
  ) {
    updateIntegration (
      id: $id
      name: $name
    ) {
      ...integrationFragment
    }
  }
  ${integrationFragment}
`;
export default mutationUpdateIntegration;
